import { render, staticRenderFns } from "./detailWebview.vue?vue&type=template&id=06b44e1c&scoped=true&"
import script from "./detailWebview.vue?vue&type=script&lang=js&"
export * from "./detailWebview.vue?vue&type=script&lang=js&"
import style0 from "./detailWebview.vue?vue&type=style&index=0&id=06b44e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b44e1c",
  null
  
)

export default component.exports